var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('feed-card',{attrs:{"feed":_vm.source,"universes":_vm.otherPropValue.universes,"events":_vm.otherPropValue.events,"configurations":_vm.relatedConfigurations,"defaultPreviewImageUrl":_vm.otherPropValue.defaultPreviewImageUrl,"unMutedFeedsUid":_vm.otherPropValue.unMutedFeedsUid,"dashboard-card":false}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3abbac54","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Feeds/feed-card.vue
// module id = VM0y
// module chunks = 1